import { render, staticRenderFns } from "./CoozzyPendingIcon.vue?vue&type=template&id=2a6056aa&scoped=true"
import script from "./CoozzyPendingIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyPendingIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyPendingIcon.vue?vue&type=style&index=0&id=2a6056aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6056aa",
  null
  
)

export default component.exports